import { render, staticRenderFns } from "./holidaysForm.vue?vue&type=template&id=42a26057&"
import script from "./holidaysForm.vue?vue&type=script&lang=js&"
export * from "./holidaysForm.vue?vue&type=script&lang=js&"
import style0 from "./holidaysForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports